import { styled } from "styled-components";

import { SectionTitleUnderlined } from "common/components";
import { useSelector } from "common/utilities/react-redux";
import { useTranslate } from "common/utilities/useTranslate";
import { getCurrentSearchTerm, getSearchIsPending } from "domains/search/selectors";

const StyledEmptyText = styled.p`
  color: ${({ theme }) => theme.colors.fillPrimary};
`;

type EmptySearchResultProps = { areDimensionsFetching: boolean };

export const EmptySearchResult = ({ areDimensionsFetching }: EmptySearchResultProps) => {
  const currentSearchTerm = useSelector(getCurrentSearchTerm);
  const isPending = useSelector(getSearchIsPending);
  const translate = useTranslate();

  const emptyText =
    currentSearchTerm.length <= 0
      ? "app.search.placeholder"
      : areDimensionsFetching || isPending
        ? "app.search.searching"
        : "app.search.results.no_results";

  return (
    <>
      <SectionTitleUnderlined>{translate("app.search.results.title")}</SectionTitleUnderlined>
      <StyledEmptyText>{translate(emptyText)}</StyledEmptyText>
    </>
  );
};
